import { render, staticRenderFns } from "./DahboardComponent.vue?vue&type=template&id=5ed75fb6&scoped=true&"
import script from "./DahboardComponent.vue?vue&type=script&lang=js&"
export * from "./DahboardComponent.vue?vue&type=script&lang=js&"
import style0 from "./DahboardComponent.vue?vue&type=style&index=0&id=5ed75fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed75fb6",
  null
  
)

component.options.__file = "DahboardComponent.vue"
export default component.exports